module.exports = __webpack_public_path__ + "static/media/blog-45.2ebb53e2.webp";